<template>
  <v-row>
    <v-col
      cols="12"
      class="mb-2"
    >
      <v-tabs>
        <v-tab exact :to="{ name: 'system-admin-affiliates-list' }">Affiliates</v-tab>
        <v-tab exact :to="{ name: 'system-admin-affiliates-statistic' }">Statistics</v-tab>
      </v-tabs>

      <v-card class="white">
        <v-card-text>
          <v-tabs-items v-model="currentTab">
            <v-tab-item
              :value="currentTab"
              transition="none"
              reverse-transition="none"
            >
              <v-row>
                <v-col cols="12" style="position: relative;">
                  <v-card>
                    <v-data-table
                      :headers="headers"
                      :items="statistic"
                      :options.sync="options"
                      :server-items-length="totalCount"
                      :loading="loading"
                      :footer-props="tableFooterProps"
                    >
                      <template v-slot:[`item.name`]="{ item }">
                        <div class="py-2">{{ item.name }}</div>
                      </template>
                      <template slot="body.append">
                        <tr>
                          <th><b>Totals</b></th>
                          <th>{{ totalStatistic.visits }}</th>
                          <th>{{ totalStatistic.unique_visits }}</th>
                          <th>{{ totalStatistic.submissions }}</th>
                          <th>{{ totalStatistic.conversion ? `${totalStatistic.conversion}` : '0%' }}</th>
                        </tr>
                       </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { TABLE_FOOTER_PROPS } from '@/global/consts';

export default {
  name: 'AdminAffiliatesStatistics',
  data: () => ({
    currentTab: 'statistic',
    loading: true,
    statistic: [],
    totalStatistic: {
      conversion: null,
      submissions: 0,
      unique_visits: 0,
      visits: 0,
    },
    totalCount: 0,
    headers: [
      {
        text: 'Affiliate Name',
        value: 'name',
      },
      {
        text: 'Views',
        value: 'visits',
      },
      {
        text: 'Unique Views',
        value: 'unique_visits',
      },
      {
        text: 'Submissions',
        value: 'submissions',
      },
      {
        text: 'Submission rate',
        value: 'conversion',
      },
    ],
    options: {
      sortBy: ['created_at'],
      sortDesc: [true]
    },
    tableFooterProps: { ...TABLE_FOOTER_PROPS },
  }),
  mounted() {
    this.getStatistic();
  },
  methods: {
    getStatistic() {
      this.loading = true;

      const queryParams = this.getStatisticQueryParams();
      const statisticRequest = this.$http.get('affiliates/statistic?' + queryParams);
      const totalStatisticRequest = this.$http.get('affiliates/statistic-full');

      Promise.all([statisticRequest, totalStatisticRequest])
        .then(([statisticResponse, totalStatisticResponse]) => {
          this.statistic = statisticResponse.data.items;
          this.totalCount = statisticResponse.data._meta.totalCount;
          this.totalStatistic = totalStatisticResponse.data.result;
        })
        .catch(err => {
          if(err.response.status == 401) return;
          this.$swal.fire('Error', 'There was an error loading affiliates', 'error')
        })
        .finally(() => this.loading = false);
    },
    getStatisticQueryParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let qParams = []

      if(sortBy[0]) qParams.push('sort=' + (sortDesc[0] ? '-' : '') + sortBy[0]);
      qParams.push('per-page=' + itemsPerPage);
      qParams.push('page=' + page);
      return qParams.join('&')
    },
    checkKeypress(e) {
      if(e.key == 'Enter') this.getStatistic()
    },
  }
}
</script>

<style scoped lang="scss">

</style>